module.exports = __webpack_public_path__ + "static/tony-005-091d62cdba7bbfb1c240d0a87dbfcdb5.jpg";